import React from "react"
import { TabLinks } from "../tab-links"
import type { TabLinksItemProps } from "../tab-links"

// =============================================================================
// Props
// =============================================================================

export type PageSecondaryHeaderTabLinkProps = TabLinksItemProps

// =============================================================================
// Component
// =============================================================================

/**
 * Secondary page header tab link. A `TabLinks.Item`, rendered as an `<a>` with
 * `aria-current="page"` when the ancestor `PageHeader`'s `currentPath` matches
 * `href`.
 *
 * Must be a descendant of `PageSecondaryHeader.TabLinks`. Compose an `Icon`
 * before the label or a `CountBadge` after it in `children`.
 *
 * Accepts a `render` prop to swap in your own link component (e.g. Inertia
 * `Link`, react-router `Link`, plain `<a>`).
 */
export const PageSecondaryHeaderTabLink = React.forwardRef<
  HTMLAnchorElement,
  PageSecondaryHeaderTabLinkProps
>(function PageSecondaryHeaderTabLink(props, ref) {
  return <TabLinks.Item ref={ref} {...props} />
})
